import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Logo, MenuItems, MenuItem, MobileIcon } from './styles';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Nav>
      <Logo to="/">
        CODHOD asbl
      </Logo>
      <MobileIcon onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </MobileIcon>
      <MenuItems $isOpen={isOpen}>
        <MenuItem>
          <Link to="/" onClick={() => setIsOpen(false)}>Accueil</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/programs" onClick={() => setIsOpen(false)}>Programmes</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/news" onClick={() => setIsOpen(false)}>Actualités</Link>
        </MenuItem>
        {/* <MenuItem>
          <Link to="/recrutement" onClick={() => setIsOpen(false)}>candidats présélectionnés</Link>
        </MenuItem> */}
        <MenuItem>
          <Link to="/focal" onClick={() => setIsOpen(false)}>Points focaux</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/about" onClick={() => setIsOpen(false)}>À propos</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
        </MenuItem>
      </MenuItems>
    </Nav>
  );
};

export default Navbar;